import {combineReducers} from 'redux';
import store from '../stores/store';

import {
  INSIDERS_SET_ONLINE,
  INSIDERS_LAST_NOTIFICATION,
  INSIDERS_TOGGLE_NOTIFICATION_PANEL,
  INSIDERS_TOGGLE_NOTIFICATION_FORM,
  INSIDERS_NOTIFICATION_SUBMIT,
  INSIDERS_NOTIFICATION_RECEIVED
} from '../actions/insidersAction';

export default function reducer(initialState={
    list: {},
    online: [],
    notifications: {
      itemClass: {
        'alert-panel': true,
        'slideDown': false
      },
      alert: {/*
        author: {
          id: 2,
          name: 'An example admin',
          current_title: 'Lorem Ispum',
          picture: ''
        },
        text: 'An example text… As a few people have pointed out, www.pathmotion.com this method can cause elements to be blurry due to the element being placed on a “half pixel”. A solution for this is to either set its parent element to preserve-3d. See all Insiders on www.pathmotion.com/app/insiders, and do not hesitate to ask them questions!'
      */}
    }
  }, action) {

    switch (action.type) {

      case INSIDERS_SET_ONLINE: {
        return {...initialState, online: [...action.payload]}
      }

      case INSIDERS_TOGGLE_NOTIFICATION_PANEL: {
        let notifications = initialState.notifications;
        let itemClass = notifications.itemClass;
        let slideDown = typeof action.state == 'undefined' ?  !(itemClass['slideDown']) : action.state;

        itemClass = {...itemClass, slideDown };
        notifications = {...notifications, itemClass};

        return {...initialState, notifications}
      }

      case INSIDERS_NOTIFICATION_SUBMIT: {
        // process a POST request into the chatMiddleware
        break;
      }

      case INSIDERS_NOTIFICATION_RECEIVED: {
        return {...initialState, notifications: {...initialState.notifications, alert: {...action.notification}} }
      }

    }

    return initialState;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/insidersReducer.jsx